export const frontmatter = {
    "draft": true,
    "title": "Seguridad y acceso",
    "sidebar_group": "referencia",
    "sidebar_label": "Seguridad y acceso",
    "sidebar_order": 1
}

export const toc = []